(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["whole-food-mixer-4col-layout"] && !Shopify.designMode) return;
  try {
    
// Optional JavaScript if needed

  } catch(e) { console.error(e); }
})();
})();
